import { Link } from "react-router-dom";
import classes from "./Section10.module.css";

export default function Section10() {
  return (
    <section className={classes.wrapper}>
      <div className={classes.grid}>
        {/* LEFT COLUMN */}
        <div className={classes.column}>
          <div className={classes.card} data-img="memory">
            <div className={classes.inner}>
              <span className={classes.tag}>Hot Deal</span>
              <h2>High-Performance DDR4 Memory Kits</h2>
              <p>
                Boost your PC performance with our premium DDR4 memory modules.
              </p>
              <Link to="/category/memory" className={classes.btn}>
                Shop Memory
              </Link>
            </div>
          </div>

          <div className={classes.card} data-img="power">
            <div className={classes.inner}>
              <span className={classes.tag}>Trending</span>
              <h2>Reliable Power Supply Units</h2>
              <p>
                Ensure stable power for your system with our efficient PSUs.
              </p>
              <Link to="/category/power-supplies" className={classes.btn}>
                Shop Power Supply
              </Link>
            </div>
          </div>
        </div>

        {/* CENTER MAIN BANNER */}
        <div
          className={`${classes.card} ${classes.tall} ${classes.centerCard}`}
          data-img="network"
        >
          <div className={classes.inner}>
            <span className={classes.tagCenter}>Featured</span>
            <h2>High-Speed Network Adapters</h2>
            <p>
              Upgrade your connectivity with our advanced network solutions.
            </p>
            <Link
              to="/category/network-accessories"
              className={classes.btnPrimary}
            >
              Explore Network
            </Link>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className={classes.column}>
          <div className={classes.card} data-img="motherboard">
            <div className={classes.inner}>
              <span className={classes.tag}>Top Rated</span>
              <h2>Premium Motherboards</h2>
              <p>
                High-quality motherboards for gaming, workstations, and servers.
              </p>
              <Link to="/category/motherboards" className={classes.btn}>
                Shop Motherboard
              </Link>
            </div>
          </div>

          <div className={classes.card} data-img="internal_ssd">
            <div className={classes.inner}>
              <span className={classes.tag}>New Arrival</span>
              <h2>Internal Hard Drives & SSDs</h2>
              <p>
                Fast, reliable storage options for all your computing needs.
              </p>
              <Link to="/category/internal-ssds" className={classes.btn}>
                Shop Storage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
